/**
 * SplashScreen Component
 * 데모 스플래시 화면
 */

import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import splashSvg from '../../../styles/images/splash.svg';
import { getUserInfo, getRequiresPasswordSetup } from '../../../core/utils';
import { getCookie } from '../../../core/utils/cookie';

const SplashScreen: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const checkLoginAndNavigate = (replace: boolean) => {
            const userInfo = getUserInfo();
            const requiresPasswordSetup = getRequiresPasswordSetup();
            const accessToken = getCookie('accessToken') || sessionStorage.getItem('accessToken');
            const isLoggedIn = !!(userInfo && (userInfo.riderId || userInfo.suppId)) || !!accessToken;
            
            if (isLoggedIn) {
                navigate('/home', { replace });
            } else if (requiresPasswordSetup) {
                navigate('/password-setup', { replace });
            } else {
                navigate('/login', { replace });
            }
        };

        const params = new URLSearchParams(location.search);
        if (params.has('skip-splash')) {
            checkLoginAndNavigate(true);
            return;
        }
        
        const timer = setTimeout(() => checkLoginAndNavigate(true), 2000);
        return () => clearTimeout(timer);
    }, [navigate, location.search]);

    return (
        <div id="splash-screen" className="screen active">
            <div className="splash-container">
                <img src={splashSvg} alt="VROONG Splash" className="splash-svg" />
            </div>
        </div>
    );
};

export default SplashScreen;
